// console.log("Compiled by \n ...Boilerplate LuanDEV...");
// console.log("ready!!!");
// var mathTest = 19 + 1;
// console.log("Math test:" + mathTest);





(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { /* The DOM is ready! */ 
        open_modal_route = function(el){

            navigator.geolocation.getCurrentPosition(geoLocationCbSuccess, geoLocationCbError);
            
            $($(el).data('modal')).addClass('active');
            $('body').addClass('no-scroll');
        
        }
    });


    function is_ie() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return 0
        {
            return false;
        }

        return false;
    }




	$(window).scroll(function(event) {
        /*var scrTopHeight = $(window).innerHeight() / 2;*/
        var scrTopHeight = 100;
		if($(window).scrollTop() > scrTopHeight){
			$('body').addClass('scrolled');
		}else{
			$('body').removeClass('scrolled');
		}
	});

    /*$('.counter').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });*/

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}


const box = document.querySelector('.count');
const message = document.querySelector('#message');

document.addEventListener('scroll', function () {
    /*const messageText = isInViewport(box) ?
        'The box is visible in the viewport' :
        'The box is not visible in the viewport';*/

    //message.textContent = messageText;
    //console.log(messageText);
    
    if (box) {
        if( isInViewport(box) ) {
            var counters = box.querySelectorAll('.run');
            const speed = 200;

            counters.forEach( counter => {
               const animate = () => {
                  const value = +counter.getAttribute('total');
                  const data = +counter.innerText;
                 
                  const time = value / speed;
                 if(data < value) {
                      counter.innerText = Math.ceil(data + time);
                      setTimeout(animate, 1);
                    }else{
                      counter.innerText = value;
                    }
                 
               }
               
               animate();
            });
        }        
    }



}, {
    passive: true
});    



	$('.nae-header-menu-button').click(function(event) {
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$('.nae-header-menu-close').removeClass('active');
			$('.nae-header-menu').removeClass('active');
			$(this).find('svg').removeClass('active');
			$('body').removeClass('menu-open');
		}else{

			$(this).addClass('active');
			$('.nae-header-menu-close').addClass('active');
			$('.nae-header-menu').addClass('active');
			$('.nae-header-menu-button svg').addClass('active');
			$('body').addClass('menu-open');
		}
	});



	$('.nae-header-menu-close').click(function(event) {
		$(this).removeClass('active');
		$('.nae-header-menu-button').removeClass('active');
		$('.nae-header-menu').removeClass('active');
		$('.nae-header-menu-button svg').removeClass('active');
		$('body').removeClass('menu-open');
	});



	window.addEventListener('resize', function(event){

		if($(window).innerWidth() > 767){

			$('.nae-header-menu-close').removeClass('active');
			$('.nae-header-menu-button').removeClass('active');
			$('.nae-header-menu').removeClass('active');
			$('.nae-header-menu-button svg').removeClass('active');
			$('body').removeClass('menu-open');
		}
		
	});







	$('.nae-footer-top-btn-container .nae-footer-top-btn').click(function(event) {
		$([document.documentElement, document.body]).animate({
                scrollTop: 0
            }, 1000);
	});




	$('.pd-player').pdplayer({
		icon_play: '<span class="icon-closed-arrow-right"></span>',
	});













	//Function  Mask
    function mask(o, f) {
        setTimeout(function () {
            var v = f(o.value);
            if (v != o.value) {
                o.value = v;
            }
        }, 1);
    }

    function mphone(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
        v = v.replace(/(\d)(\d{4})$/, "$1-$2");
        return v;
    }

    function mcep(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{5})(\d{3})?/, "$1-$2");
        return v;
    }

    function mnum(v) {
        v = v.replace(/\D/g, "");
        return v;
    }

    function memail(v) {
        v = v.replace(/[()+=#%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        var parts = v.split('@');
        v = "";
        for(var i = 0; i < parts.length; i++){
            if(i == 1){
                v += "@";
            }
            v += parts[i];
        }
        
        return v;
    }

    function mtext(v) {
        v = v.replace(/[0123456789()_+-=#@%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        return v;
    }

    $('input[type="tel"],.mask-tel').keypress(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keypress(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keypress(function() {
        mask(this, mcep);
    });

    $('input.mask-num').keypress(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keypress(function() {
        mask(this, mtext);
    });

    $('input[type="tel"],.mask-tel').change(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').change(function() {
        mask(this, memail);
    });


    $('input.mask-cep').change(function() {
        mask(this, mcep);
    });

    $('input.mask-num').change(function() {
        mask(this, mnum);
    });

    $('input.mask-text').change(function() {
        mask(this, mtext);
    });



    $('input[type="tel"],.mask-tel').keyup(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keyup(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keyup(function() {
        mask(this, mcep);
    });

    $('input.mask-num').keyup(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keyup(function() {
        mask(this, mtext);
    });





    $("form:not(.no-validate)").submit(function(event) {

        if($(this).hasClass('wpcf7-form')){

            $(this).find('input[type=submit]').attr({ disabled: '' });
            $(this).addClass('loading');
        }

        var inputs = $(this).find('input:not(.no-validate)');
        var textareas = $(this).find('textarea:not(.no-validate)');
        var selects = $(this).find('select:not(.no-validate)');

        var error = false;

        inputs.each(function(index, el) {
            if(el.value == "" || el.value == null ){
                $(el).addClass('nae-form-error');
                error = true
            }
        });

        textareas.each(function(index, el) {
            if(el.value == "" || el.value == null ){
                $(el).addClass('nae-form-error');
                error = true
            }
        });

        selects.each(function(index, el) {
            if(el.value == "" || el.value == null || el.value == "Assunto" || el.value == "Cidade" ){
                $(el).parents('.nae-form-select-container').addClass('nae-form-error');
                error = true
            }
        });




        if(error){
            event.preventDefault();
        }
    });



    $("form").each(function(event) {
        var inputs = $(this).find('input');
        var textareas = $(this).find('textarea');
        var selects = $(this).find('select');

        

        inputs.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('nae-form-error');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    // console.log($(el).parent().find('.wpcf7-not-valid-tip'));
                }
            });
            
        });

        textareas.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('nae-form-error');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        selects.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null && el.value != "UF" && el.value != "Cidade" ){
                    $(el).parents('.nae-form-select-container').removeClass('nae-form-error');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });


    });






    //Function to redirect form after submit
    document.addEventListener( 'wpcf7mailsent', function( event ) {

        var link = $(event.srcElement).parents('div[data-thanks-link]').data('thanks-link');
        location = link;
    }, false );
    //End
    
    
    

    //libera botão de submit
    document.addEventListener( 'wpcf7invalid', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7spam', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7mailfailed', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
    }, false );



    

    //Remove carregando
    document.addEventListener( 'wpcf7submit', function( event ) {
        $(event.srcElement).find('form.wpcf7-form').removeClass('loading');
    }, false );





    var mapContact = document.getElementById('nae-contact-infos-map');
    if (mapContact != null) {
        var geocoder = new google.maps.Geocoder;
        // Search for routes
        var directionsService = new google.maps.DirectionsService();        
        // Render the routes
        var directionsDisplay = new google.maps.DirectionsRenderer();  

        var location_finish;
        
        var map;  

        google.maps.event.addDomListener(window, 'load', function(){

            
            var bounds = new google.maps.LatLngBounds();
            var mapOptions = {
                scrollwheel: false,
                mapTypeId: 'roadmap'
            };
                            
            // Display a map on the page
            map = new google.maps.Map(mapContact, mapOptions);
            map.setTilt(45);

            directionsDisplay.setMap(map);


            map.n_markers = [];

                
            // Multiple Markers
            var markers = [
                ['NAE - Núcleo Arte Educação', -23.548227, -46.5763735,'']
            ];
                                
            // Info Window Content
            var infoWindowContent = [
                ['<div class="location-info"><span class="icon-pin-map"></span><a href="https://goo.gl/maps/zrcmV7rbj75sgMc67">Rua Bom Sucesso, 1119 <br>Tatuapé - São Paulo, SP </a></div>'+ 
                ' <span class="link-default nae-modal-btn" data-modal="nae-map-route-modal" onclick="open_modal_route(this);><p>Traçar rota</p><span class="icon-arrow-right"></span></span>'
                + '</div>']
            ];


            if(mapInfo != null){
                markers = [
                    [mapInfo.title, mapInfo.lat, mapInfo.long, mapInfo.icon]
                ];

                if(is_ie()){
                    markers[0][3] = '';
                }


                infoWindowContent = [[
                            '<div class="info-content">'+
                            '<h4>'+ mapInfo.title +'</h4><br/>'+
                                mapInfo.text 
                            + '</div>'
                        ]];
            }

            geocoder.geocode({ 'location': { lat: markers[0][1], lng: markers[0][2] } }, function(results, status){
                location_finish = results[0];
            });

                
            // Display multiple markers on a map
            var infoWindow = new google.maps.InfoWindow(), marker, i;
            
            // Loop through our array of markers & place each one on the map  
            for( i = 0; i < markers.length; i++ ) {
                var position = new google.maps.LatLng(markers[i][1], markers[i][2], markers[i][3]);
                bounds.extend(position);
                marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: {
                        url: markers[i][3],
                        scaledSize: new google.maps.Size(48, 48)
                    },
                    title: markers[i][0]
                });

                map.n_markers.push(marker);
                
                // Allow each marker to have an info window    
                google.maps.event.addListener(marker, 'click', (function(marker, i) {
                    return function() {
                        infoWindow.setContent(infoWindowContent[i][0]);
                        infoWindow.open(map, marker);
                    }
                })(marker, i));

                // Automatically center the map fitting all markers on the screen
                map.fitBounds(bounds);
                
            }

            // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
            var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
                this.setZoom(17);
                google.maps.event.removeListener(boundsListener);
            }); 

        });


        $('.modal-route-location .modal-route-form').submit(function(event) {
            event.preventDefault();
            


            var locationTypeSelected = $(this).find('input.modal-route-radio:checked');
            var personalizedLocation = locationTypeSelected.parent().find('.modal-route-input');

            // console.log(personalizedLocation);
            // return;

            if(personalizedLocation.length === 0){
                if(currentLocationCoords !== null){
                    geocoder.geocode(currentLocationCoords, function(results, status){
                        if(status === 'OK'){
                            generateRoute(results[0].formatted_address, location_finish.formatted_address);
                            $('#select-location-type').addClass('routing-enabled');
                            $('.eco-routing-loader').addClass('active');
                        }
                    });
                }else{
                    $('.enable-location-alert').addClass('denied-access');
                    locationDeniedAlertEnabled = true;

                    $('#enable-location').click(function(){
                        $('.enable-location-alert').removeClass('denied-access');
                        locationDeniedAlertEnabled = false;
                    });
                }           
            }else if(personalizedLocation.length > 0){
                if(personalizedLocation.val() == ''){
                    personalizedLocation.addClass('nae-form-error');
                }else{
                    generateRoute(personalizedLocation.val(), location_finish.formatted_address);
                    
                }
            }
        });

        $('.modal-route-location .modal-route-form .modal-route-radio[name=modal-route-radio]').change(function(event) {
            if(this.value == 'false'){
                $('.nae-map-route-modal .denied-geolocation').removeClass('active');
            }else{
                navigator.geolocation.getCurrentPosition(geoLocationCbSuccess, geoLocationCbError);
                if(currentLocationCoords == null){
                    $('.nae-map-route-modal .denied-geolocation').addClass('active');
                }
            }

        });

        $('.modal-route-form .modal-route-input').focus(function(){
            // this.classList.remove('eco-form-error');

            // Autocomplete for other location routing
            new google.maps.places.Autocomplete(this).setComponentRestrictions({'country': ['br']});
        });
   
    }

    // -> Geolocation helpers
    function geoLocationCbSuccess(position){
        currentLocationCoords = {
            'location': {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            }
        };
    }

    function geoLocationCbError(error){
        
        if(error.code == 1 && $('.modal-route-location .modal-route-form .modal-route-radio[name=modal-route-radio]:checked')[0].value != "false"){
            $('.nae-map-route-modal .denied-geolocation').addClass('active');
        }

        currentLocationCoords = null;
    }

    function generateRoute(from, to){
        var service = new google.maps.DistanceMatrixService();
        
        service.getDistanceMatrix({
            origins: [from],
            destinations: [to],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false
        }, generateRouteCb);
    }

    function generateRouteCb(response, status){
        if(status !== google.maps.DistanceMatrixStatus.OK){
            alert('Não foi possível calcular a rota!');
        }else{
            var from = response.originAddresses[0];
            var to = response.destinationAddresses[0];

            if(response.rows[0].elements[0].status === 'ZERO_RESULTS'){
                alert('Não foi possível traçar nenhuma rota!');
            }else if(response.rows[0].elements[0].status === 'NOT_FOUND'){
                alert('Não foi possível traçar nenhuma rota!');
            }else{
                var distance = response.rows[0].elements[0].distance;
                var distanceText = distance.text;
                var duration = response.rows[0].elements[0].duration;
                var durationText = duration.text;
                var km = distanceText.substring(0, distanceText.length - 3);

                $('.map-routing-results').addClass('active');
                $('.map-routing-origin-address').text(from);
                $('.map-routing-destination-address').text(to);
                $('.map-routing-distance').text(km + ' km');
                $('.map-routing-duration').text(durationText);

                var request = {
                    origin: from,
                    destination: to,
                    travelMode: 'DRIVING'
                };
                
                directionsService.route(request, function(result, status){
                    if(status === 'OK'){
                        directionsDisplay.setDirections(result);
                        map.n_markers[0].setMap(null);
                        
                        $('.nae-modal .modal-close-btn').click();
                    }
                });
            }
        }
    }




    $('.nae-tabs .nae-tabs-header-item:first-child, .nae-tabs .nae-tabs-body-item:first-child').each(function(index, el) {
        $(this).addClass('active');
    });

    $('.nae-tabs .nae-tabs-header-item').click(function(event) {
        $(this).parents('.nae-tabs').find('.nae-tabs-header-item').removeClass('active');
        $(this).parents('.nae-tabs').find('.nae-tabs-body-item').removeClass('active');
        $(this).addClass('active');

        $($(this).parents('.nae-tabs').find('.nae-tabs-body-item')[$(this).parents('.nae-tabs').find('.nae-tabs-header-item').index(this)]).addClass('active');
    });




    $('.nae-modal-btn[data-modal]').click(function(event) {
        $($(this).data('modal')).addClass('active');
        $('body').addClass('no-scroll');
    });


    $('.nae-modal .modal-close, .nae-modal .modal-close-btn').click(function(event) {
        $(this).parents('.nae-modal').removeClass('active');
        $('body').removeClass('no-scroll');
    });


    $('.nae-paginator-form').submit(function(event) {
        event.preventDefault();
        var input = $('input.current');
        
        if(input[0].value == '' || input[0].value == this.current){
            input[0].value = this.current;
            return;
        }


        if(input[0].value < 1){
            input[0].value = 1;
            return;
        }

        if(input[0].value > this.max){
            input[0].value = this.max;
            return;
        }

        location = $(this).data('url-base').replace("{num_page}", input[0].value);

    });

    $('.nae-paginator-form').each(function(index, el) {
        var input = $('input.current');
        el.max = $(this).data('max-page');
        el.current = input[0].value;
    });


    $('.nae-licensed-section .nae-licensed-container .question-btn').click(function(event) {
        if($(this).data('action') == 'link'){
            window.location.href = $(this).attr('href');
        }else if ($(this).data('action') == 'enter') {
            console.log(this);
            $(this).parents('.question').addClass('d-none');
            $('.nae-licensed-section .nae-licensed-container .items').addClass('active');
        }
        // $(this).parents('.question').addClass('d-none');
        // $('.nae-licensed-section .nae-licensed-container .items').addClass('active');
    });
    

    $('.nae-licensed-section .nae-licensed-container .question input[type=checkbox]').change(function(event) {
    
        $(this).parents('.question-item').find('.question-btn').prop({
            disabled: (!this.checked),
        })
    });

    $('a').click(function(event) {
        var hash = this.hash;

        if (hash) {
            var target = $(hash);

            if (target.length > 0) {
                event.preventDefault();
                
                $([document.documentElement, document.body]).animate({
                    scrollTop: target.offset().top
                }, 650);
            }
        }
    });

    
}(window.jQuery, window, document));